// extracted by mini-css-extract-plugin
module.exports = {"row":"_c4652ad0","item":"_23dd48f","link":"_1ce6359a"};